import React from "react";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import EmailIcon from '@mui/icons-material/Email';
import '../assets/styles/Footer.scss';

function Footer() {
  return (
    <footer>
      <div className="footer-icons">
        <a href="https://github.com/2002utkarsh" target="_blank" rel="noreferrer">
          <GitHubIcon />
        </a>
        <a href="https://www.linkedin.com/in/utkarsh-gupta424/" target="_blank" rel="noreferrer">
          <LinkedInIcon />
        </a>
        <a href="mailto:utkarsh.gupta424@gmail.com" target="_blank" rel="noreferrer">
          <EmailIcon />
        </a>
      </div>
      <p>© {new Date().getFullYear()} Utkarsh Gupta. All rights reserved.</p>
    </footer>
  );
}

export default Footer;
